import React, { FC } from 'react'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ModalType } from 'src/Types'

import { SpotifyGenresModal } from '../SpotifyGenresModal'

import { LanguagesModalSpotifyWrapper } from './LanguagesModalSpotifyWrapper'

export const SpotifyScheduleModals: FC = () => {
  const { search } = useCustomSearchParams()

  if (search.get('modal') === ModalType.Genres) {
    return <SpotifyGenresModal />
  }
  if (search.get('modal') === ModalType.Languages) {
    return <LanguagesModalSpotifyWrapper />
  }
  return null
}
